{
  "name": "kkp-app-client",
  "private": true,
  "version": "1.0.0",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "tsc -b && vite build",
    "preview": "vite preview",
    "lint": "eslint . --max-warnings 0",
    "format": "prettier . --write",
    "test": "vitest run --passWithNoTests",
    "test:watch": "vitest"
  },
  "dependencies": {
    "@hookform/resolvers": "^5.4.0",
    "@kkp/api-client": "*",
    "@kkp/app-kit": "*",
    "@kkp/features": "*",
    "@kkp/ui": "*",
    "@radix-ui/react-dialog": "^1.1.18",
    "@radix-ui/react-dropdown-menu": "^2.1.19",
    "@radix-ui/react-popover": "^1.1.18",
    "@radix-ui/react-tabs": "^1.1.16",
    "@radix-ui/react-tooltip": "^1.2.11",
    "@tanstack/react-query": "^5.101.2",
    "clsx": "^2.1.1",
    "date-fns": "^4.4.0",
    "flowbite": "^4.0.2",
    "lucide-react": "^1.23.0",
    "react": "^19.2.7",
    "react-dom": "^19.2.7",
    "react-hook-form": "^7.80.0",
    "react-router-dom": "^7.18.1",
    "sonner": "^2.0.7",
    "tailwind-merge": "^3.6.0",
    "typescript": "^6.0.3",
    "zod": "^4.4.3",
    "zustand": "^5.0.1"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@tailwindcss/vite": "^4.3.2",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@types/jsdom": "^28.0.3",
    "@types/react": "^19.2.17",
    "@types/react-dom": "^19.2.3",
    "@vitejs/plugin-react": "^6.0.3",
    "autoprefixer": "^10.5.2",
    "eslint": "^10.6.0",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-react-refresh": "^0.5.3",
    "globals": "^17.7.0",
    "jsdom": "^29.1.1",
    "postcss": "^8.5.16",
    "prettier": "^3.9.4",
    "tailwindcss": "^4.3.2",
    "typescript-eslint": "^8.62.1",
    "vite": "^8.1.2",
    "vitest": "^4.0.16"
  }
}
